import { v4 as uuidv4 } from 'uuid';

const continentsData = [
  {
    id: uuidv4(),
    name: 'Africa',
    map: '',
    image: '/images/Africa.svg',
  },
  {
    id: uuidv4(),
    name: 'Asia',
    map: '',
    image: '/images/Asia.svg',
  },
  {
    id: uuidv4(),
    name: 'Europe',
    map: '',
    image: '/images/Europe.svg',
  },
  {
    id: uuidv4(),
    name: 'Oceania',
    map: '',
    image: '/images/Oceania.svg',
  },
  {
    id: uuidv4(),
    name: 'North America',
    map: '',
    image: '/images/North America.svg',
  },
  {
    id: uuidv4(),
    name: 'South America',
    map: '',
    image: '/images/South America.svg',
  },
  {
    id: uuidv4(),
    name: 'Antarctica',
    map: '',
    image: '/images/Antarctica.svg',
  },
];

export default continentsData;
